<div class="search-box-wrapper">
  <div class="ui small action static-search input">
    <input type="text" placeholder="Search" [(ngModel)]="keyword" (keyup.enter)="onSearch()" (ngModelChange)="onKeywordChange($event)">
    <button class="ui basic icon button" (click)="onSearch()"><i class="search icon"></i></button>
  </div>
  @if (suggestions.length > 0) {
    <div class="results">
      @for (s of suggestions; track s) {
        <div class="result" (click)="onSelectSuggestion(s)">
          {{s}}
        </div>
      }
    </div>
  }
</div>
